import { FileTypes } from './false-deals-admin.types';

export const FILESIZE_LIMIT = 150;
export const FILES_LIMIT = 5;

export const DELETION_FILESIZE_LIMIT = 50;
export const DELETION_FILES_LIMIT = 3;

export const TAXPAYER_TYPES = {
    FL: 'ФЛ',
    IP: 'ИП',
    IPS: 'ИПС',
    UL: 'ЮЛ',
    UL_NR: 'ЮЛ',
    FL_NR: 'ФЛ',
    LZCHP: 'ЛЗЧП',
};

export const NO_NAME = '(Наименование отсутствует)';

export const DATE_FORMAT = 'DD.MM.YYYY';
export const REQUEST_DATE_FORMAT = 'YYYY-MM-DD';

export const fileFieldsLabels: Record<FileTypes, string> = {
    [FileTypes.ACT]: 'Судебный акт',
    [FileTypes.CONFIRMATION]: 'Подтверждающий документ',
    [FileTypes.DELETION]: 'Подтверждающий документ',
    [FileTypes.COUNTERPARTY]: 'Список контрагентов',
};

export const fileDownloadEndpoints: Record<FileTypes, string> = {
    [FileTypes.ACT]: 'act-file',
    [FileTypes.CONFIRMATION]: 'confirmation-doc',
    [FileTypes.DELETION]: 'deletion-doc',
    [FileTypes.COUNTERPARTY]: 'counterparty-file',
};
